export { default as DecorativeDivider, imageParams } from './DecorativeDivider';
